module.exports = __webpack_public_path__ + "static/media/selfLearningBook.2f1f7b79.svg";